/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CloseAction from './CloseAction/index'
import Iframe from 'DesignSystem/Iframe/react'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/AnalysesTree/Analyses/Content/CalibrationToolModal/Content"
  
}) {
let selectedEditAnalysisUrlValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'edit_analysis_url',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="90%"
 width="90%"
 overflow="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Iframe
{...childProps}
  viewPath={`${viewPath}/Iframe`}
 data="selected.edit_analysis_url"
 src={selectedEditAnalysisUrlValueData}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}